var React = require('react');

function Move (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 9L2 12M2 12L5 15M2 12H22M9 5L12 2M12 2L15 5M12 2V22M15 19L12 22M12 22L9 19M19 9L22 12M22 12L19 15","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Move.defaultProps = {"width":"26px","height":"26px","viewBox":"0 0 26 26","fill":"none"};

module.exports = Move;

Move.default = Move;
